//third-party
import PageViewer from "../Site/PageViewer";

function AiAnswer({ aiAnswerText }) {
	return (
		<div style={{ overflow: "auto" }}>
			<h2>Ответ ИИ: </h2>
			<PageViewer content={aiAnswerText} />
		</div>
	);
}

export default AiAnswer;
